import L from 'leaflet';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

/**
 * CRA/Webpack ignores Leaflet's built-in relative image paths. Map modules
 * mistakenly "fixed" this by setting iconUrl to undefined, which breaks every
 * Marker that relies on the default icon (e.g. coffee card mini-map).
 *
 * Import this module once from the app entry before any map mounts.
 */
delete (L.Icon.Default.prototype as unknown as { _getIconUrl?: unknown })._getIconUrl;
L.Icon.Default.mergeOptions({
    iconUrl,
    iconRetinaUrl,
    shadowUrl,
});
